module.exports = __webpack_public_path__ + "img/add.cb14c3f2.svg";